import React, { useEffect, useRef } from 'react'
export function AnnouncementBanner({ banner, onSeen, onDismiss, seenDelayMs = 60000 }) {
  const { data, status, error, seenRequested } = banner
  const timerRef = useRef(null)
  const observerRef = useRef(null)
  useEffect(() => {
    if (seenRequested || data.read_behavior !== 'mark_on_view') return
    const startTimer = () => {
      if (timerRef.current) return
      timerRef.current = setTimeout(() => {
        onSeen(data.id)
      }, seenDelayMs)
    }
    const cancel = () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current)
        timerRef.current = null
      }
    }
    const el = document.querySelector(`[data-testid="announcement-${data.id}"]`)
    if (!('IntersectionObserver' in window)) {
      startTimer()
      return () => cancel()
    }
    if (el) {
      observerRef.current = new IntersectionObserver(entries => {
        entries.forEach(e => {
          if (e.isIntersecting) {
            startTimer()
          } else {
            cancel()
          }
        })
      }, { threshold: 0.1 })
      observerRef.current.observe(el)
    } else {
      startTimer()
    }
    return () => {
      cancel()
      if (observerRef.current && el) observerRef.current.unobserve(el)
    }
  }, [seenRequested, data.read_behavior, data.id, onSeen, seenDelayMs])
  if (status === 'hidden') return null
  return (
    <div role='region' aria-label='Systemmeddelande' className='announcement-banner fade-in' data-testid={`announcement-${data.id}`}>
      <div className='announcement-content'>
        <div className='announcement-text'>
          <strong className='announcement-title'>{data.title}</strong>
          <div className='announcement-body'>{data.body}</div>
          {error && <div className='announcement-error text-danger small mt-1'>{error}</div>}
        </div>
        {data.dismissible && (
          <button type='button' aria-label='Stäng meddelande' className='announcement-dismiss' onClick={() => onDismiss(data.id)} data-testid={`dismiss-${data.id}`}>
            ×
          </button>
        )}
      </div>
    </div>
  )
}
